import { render, staticRenderFns } from "./clientIteration.vue?vue&type=template&id=55f7daaf&scoped=true&"
import script from "./clientIteration.vue?vue&type=script&lang=js&"
export * from "./clientIteration.vue?vue&type=script&lang=js&"
import style0 from "./clientIteration.vue?vue&type=style&index=0&id=55f7daaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7daaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f7daaf')) {
      api.createRecord('55f7daaf', component.options)
    } else {
      api.reload('55f7daaf', component.options)
    }
    module.hot.accept("./clientIteration.vue?vue&type=template&id=55f7daaf&scoped=true&", function () {
      api.rerender('55f7daaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/roadmap/clientIteration.vue"
export default component.exports